import type { ReactNode } from 'react';

import { Box, Divider, type SxProps, type Theme } from '@mui/material';

import EntityCardStatistics, { type EntityCardStatistic } from './EntityCardStatistics';

type EntityCardDetailsProps = {
	metadata?: ReactNode;
	statistics: EntityCardStatistic[];
	action: ReactNode;
	horizontalPadding?: number;
	metadataSx?: SxProps<Theme>;
	statisticsSx?: SxProps<Theme>;
	actionSx?: SxProps<Theme>;
};

/** Consistent full-bleed metrics and action footer for gallery cards. */
export default function EntityCardDetails({ metadata, statistics, action, horizontalPadding = 2, metadataSx, statisticsSx, actionSx }: EntityCardDetailsProps) {
	return (
		<>
			{metadata && <Box sx={metadataSx}>{metadata}</Box>}
			<Divider sx={{ mx: -horizontalPadding, mt: 1.5 }} />
			<EntityCardStatistics items={statistics} sx={statisticsSx} />
			<Divider sx={{ mx: -horizontalPadding, mt: 1.5 }} />
			<Box sx={[{ pt: 0.75 }, ...(Array.isArray(actionSx) ? actionSx : actionSx ? [actionSx] : [])]}>{action}</Box>
		</>
	);
}
